export type Status = 'backlog' | 'todo' | 'inprogress' | 'booked' | 'paid';

// Items in backlog are candidates — not yet part of the budget. All budget
// totals (header Expected/Paid/Remaining, category %) exclude backlog items.
export const BACKLOG: Status = 'backlog';

export interface Payment {
  id: string;
  date: string;
  amount: number;
  note: string;
}

export interface Attachment {
  id: string;
  url: string;
}

export interface Item {
  id: string;
  title: string;
  categoryIds: string[];
  expectedPrice: number;
  payments: Payment[];
  vendor: string;
  dueDate: string;
  priority: boolean;
  notes: string;
  attachments: Attachment[];
  status: Status;
}

export interface Category {
  id: string;
  name: string;
}

export type Rsvp = 'pending' | 'confirmed' | 'declined';
export type Side = 'bride' | 'groom' | 'both';

export interface Guest {
  id: string;
  name: string;
  side: Side;
  rsvp: Rsvp;
  plusOne: boolean;
  checkedIn: boolean;
  notes: string;
}

export interface Board {
  title: string;
  categories: Category[];
  items: Item[];
  guests: Guest[];
}

// Backlog/todo are candidates — payments only unlock from inprogress onward.
export const PAYABLE: Status[] = ['inprogress', 'booked', 'paid'];
export const isPayable = (s: Status) => PAYABLE.includes(s);

export const STATUSES: { id: Status; label: string; accent: string }[] = [
  { id: 'backlog', label: 'Backlog', accent: 'oklch(75% 0.02 60)' },
  { id: 'todo', label: 'To Do', accent: 'oklch(70% 0.02 60)' },
  { id: 'inprogress', label: 'In Progress', accent: 'oklch(60% 0.1 90)' },
  { id: 'booked', label: 'Booked', accent: 'oklch(50% 0.1 20)' },
  { id: 'paid', label: 'Paid', accent: 'oklch(46% 0.07 145)' },
];

export const TAG_PALETTE = [
  { bg: 'oklch(94% 0.03 20)', text: 'oklch(40% 0.1 20)' },
  { bg: 'oklch(93% 0.03 145)', text: 'oklch(38% 0.07 145)' },
  { bg: 'oklch(93% 0.02 60)', text: 'oklch(40% 0.02 50)' },
  { bg: 'oklch(93% 0.03 280)', text: 'oklch(40% 0.06 280)' },
  { bg: 'oklch(94% 0.03 90)', text: 'oklch(42% 0.07 90)' },
];
